'use strict';
const DIALOG_REGISTRY = require('../dialog.registry');


module.exports = (app) => app.controller('accountAssignmentDetailDialog', /* @ngInject */ function ($scope, dialogService, accountAssignmentService, $timeout) {

	let dialogId;

	/**
	 * @type {any[]}
	 */
	let accountAssignments = null;
	let searchFunction = null;
	let accountAssignmentType = null;
	let customerCompanyId = null;

	$scope.filterString = '';
	$scope.hasRemainingBudgetField = false;
	$scope.filteredEntries = [];
	$scope.customerCompanyCurrency = 'EUR';
	$scope.isLoading = false;

	$scope.init = init;
	$scope.filterEntries = filterEntries;
	$scope.selectEntry = selectEntry;

	const ACCOUNT_ASSIGNMENT_TYPES = accountAssignmentService.ACCOUNT_ASSIGNMENT_TYPES;

	function init() {
		dialogId = DIALOG_REGISTRY.ACCOUNT_ASSIGNMENT_DETAIL.id;
		const data = dialogService.getData(dialogId);
		if(data){
			// Handle new data structure with type information
			if (data.entries && data.type) {
				// New structure: data contains entries and type
				accountAssignments = data.entries;
				accountAssignmentType = data.type;
				customerCompanyId = data.customerCompanyId || null;
				// Set up search function based on passed type
				setupSearchFunction(data.type, data.customTypeId);
			} else {
				// Fallback: old structure where data is directly the entries
				accountAssignments = data;
				// Determine account assignment type and set up search function (legacy)
				determineAccountAssignmentType();
			}
			
			$scope.hasRemainingBudgetField = accountAssignments.slice().some(dto => typeof dto.remainingBudget === 'number');
			
			setCurrency();
			// Load initial data with empty search
			filterEntries('');
		}
	}

	/**
	 * Set up search function based on the provided account assignment type
	 * @param {string} type - The account assignment type
	 * @param {string|null} customTypeId - The custom type ID for custom account assignments
	 */
	function setupSearchFunction(type, customTypeId = null) {
		accountAssignmentType = type;

		switch (type) {
			case ACCOUNT_ASSIGNMENT_TYPES.CUSTOM:
				if (customTypeId) {
					searchFunction = (query) => accountAssignmentService.searchCustomAccountAssignments(customTypeId, query, undefined, customerCompanyId);
				} else {
					console.error('Custom account assignment type requires customTypeId');
					searchFunction = null;
				}
				break;
			case ACCOUNT_ASSIGNMENT_TYPES.COST_CENTER:
				searchFunction = (query) => accountAssignmentService.searchCostCenters(query, undefined, customerCompanyId);
				break;
			case ACCOUNT_ASSIGNMENT_TYPES.PROJECT:
				searchFunction = (query) => accountAssignmentService.searchProjects(query, undefined, customerCompanyId);
				break;
			case ACCOUNT_ASSIGNMENT_TYPES.ACCOUNT:
				searchFunction = (query) => accountAssignmentService.searchAccounts(query, undefined, customerCompanyId);
				break;
			default:
				console.error('Unknown account assignment type:', type);
				searchFunction = null;
		}
	}

	/**
	 * Legacy function to determine account assignment type from data structure
	 * Used as fallback when type is not explicitly passed
	 */
	function determineAccountAssignmentType() {
		if (!accountAssignments || accountAssignments.length === 0) {
			return;
		}

		const firstEntry = accountAssignments[0];
		
		// Check if it's a custom account assignment (has type property)
		if (firstEntry.type) {
			setupSearchFunction(ACCOUNT_ASSIGNMENT_TYPES.CUSTOM, firstEntry.type);
		}
		// Check for cost center (has specific properties or structure)
		else if (firstEntry.costCenter || (firstEntry.code && firstEntry.code.match(/^\d{4}$/))) {
			setupSearchFunction(ACCOUNT_ASSIGNMENT_TYPES.COST_CENTER);
		}
		// Check for project (has project-specific properties)
		else if (firstEntry.project || (firstEntry.code && firstEntry.code.match(/^[A-Z]/))) {
			setupSearchFunction(ACCOUNT_ASSIGNMENT_TYPES.PROJECT);
		}
		// Default to account
		else {
			setupSearchFunction(ACCOUNT_ASSIGNMENT_TYPES.ACCOUNT);
		}
	}

	function setCurrency() {
		const companyStr = localStorage.getItem(STORAGE_KEY.EPROC_CUSTOMER_COMPANY);
		if(companyStr) {
			const company = JSON.parse(companyStr);
			$scope.customerCompanyCurrency = company.currency;
		}
	}

	async function filterEntries(filter = ''){
		// Try to keep keyboard focus on the search input when results refresh
		const inputEl = document.getElementById('accountingDialogSearch');

		try {
			$scope.isLoading = true;

			if (typeof searchFunction === 'function') {
				const results = await searchFunction(filter);
				$scope.filteredEntries = results || [];
			} else {
				// Fallback: if no search function is configured, show the passed-in entries
				$scope.filteredEntries = Array.isArray(accountAssignments) ? accountAssignments : [];
			}
			// Update hasRemainingBudgetField based on current entries
			$scope.hasRemainingBudgetField = $scope.filteredEntries.some(dto => typeof dto.remainingBudget === 'number');
		} catch (error) {
			console.error('Search failed:', error);
			$scope.filteredEntries = [];
		} finally {
			$scope.isLoading = false;
			$scope.$apply(); // Ensure scope is updated
			// Restore focus safely (element may not exist yet)
			if (inputEl && typeof inputEl.focus === 'function') {
				inputEl.focus();
			} else {
				$timeout(() => {
					const el = document.getElementById('accountingDialogSearch');
					if (el && typeof el.focus === 'function') {
						el.focus();
					}
				}, 0);
			}
		}
	}

	function selectEntry(entry){
		dialogService.closeDialog(dialogId, entry);
	}

});
